import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {
    iouList: [], // 可开票借据列表
    selectedIouIds: [] // 已选中的借据id
  },

  mutations: {
    setIouList (state, list) {
      state.iouList = list
    },
    setSelectedIouIds (state, ids) {
      state.selectedIouIds = ids
    },
    toggleIouSelection (state, id) {
      const index = state.selectedIouIds.indexOf(id)
      if (index > -1) {
        state.selectedIouIds.splice(index, 1)
      } else {
        state.selectedIouIds.push(id)
      }
    },
    clearSelection (state) {
      state.selectedIouIds = []
    }
  },

  actions: {
    // 查询用户可开发票列表
    async getInvoiceIouListX ({ commit }) {
      const response = await axios.post('/invoice/queryUserCanInvoiceList')
      return response.data
    },

    // 申请开发票
    async submitInvoiceApplyX (store, params) {
      const response = await axios.post('/invoice/apply', params)
      return response.data
    },

    // 查询已申请发票列表
    async getInvoiceProgressListX ({ commit }) {
      const response = await axios.post('/invoice/queryUserApplyInvoiceList')
      return response.data
    },

    // 查询发票申请详情
    async getInvoiceDetailX (store, params) {
      const response = await axios.post('/invoice/invoiceDetail', params)
      return response.data
    }
  }
}
